import React from "react";
import { CV } from "../components/cv";
import AlexNImg from "@/assets/images/alex-n.png";

export default function CVAlexanderNyberg() {
  React.useEffect(() => {
    document.title = "BoldBrave CV - Alexander Nyberg";
  }, []);

  return (
    <CV
      name="Alexander Nyberg"
      title="Enterprise Architect · Interim CIO"
      subtitle="IT strategy and digital transformation across retail and fitness — long-term engagement at Fitness24Seven"
      photo={AlexNImg}
      summary="Strategic Enterprise Architect and interim CIO with 15+ years of leading IT strategy, architecture, and delivery across retail and fitness. Drives transformations from target architecture and roadmaps to live solutions in cloud, networking, ERP, and digital products, with accountability for budget, vendors, and cross-functional teams."
      skills={{
        "Architecture": ["Enterprise Architecture", "Target Architecture", "Solution Architecture", "Roadmapping"],
        "Leadership": ["Interim CIO", "IT Strategy", "Team Leadership", "Vendor & Budget Management"],
        "Cloud & Infra": ["Azure", "SD-WAN", "ERP & Retail IT"],
        "Methods": ["Agile/SAFe", "DevOps", "IT Governance", "Service Management", "Project & Program Management"],
        "Languages": ["Swedish (native)", "English (fluent)", "German (basic)"],
      }}
      experience={[
        {
          role: "Enterprise Architect (consultant)",
          company: "Fitness24Seven AB",
          period: "Nov 2023 – Jun 2025",
          description:
            "Defined target state for IT systems, IT organization, and digital solutions for an international gym chain with nearly 300 sites.",
          highlights: [
            "Shaped vision and roadmaps guiding investments, priorities, and capabilities.",
            "Facilitated alignment between business, IT, and vendors on target architecture and value.",
          ],
        },
        {
          role: "Interim CIO (consultant)",
          company: "Fitness24Seven AB",
          period: "Oct 2021 – Apr 2022; Sep – Oct 2024",
          description:
            "Overall responsibility for the IT department including digital development, operations, and maintenance of business-critical systems.",
          highlights: [
            "Prioritized portfolio, budget, and staffing in close collaboration with leadership and operations.",
            "Secured vendor management and stable operations during organizational change.",
          ],
        },
        {
          role: "IT Architect (consultant)",
          company: "Fitness24Seven AB",
          period: "Aug 2023 – Oct 2023",
          description:
            "Technical architect for a new mobile access solution now used at the majority of gyms.",
          highlights: [
            "Drove requirements, architecture, and rollout with product, security, and operations teams.",
          ],
        },
        {
          role: "IT Project Manager (consultant)",
          company: "Fitness24Seven AB",
          period: "Jan 2020 – Sep 2021; May – Jul 2022",
          description: "Led strategic IT projects with strong technical ownership.",
          highlights: [
            "Standardized networks and SD-WAN across all gyms.",
            "Migration from datacenter to Microsoft Azure.",
            "Upgraded and moved ERP to the cloud for all European gyms.",
            "IT lead for launching the The I/O gym concept in Spain.",
          ],
        },
        {
          role: "IT Service Manager (consultant)",
          company: "Fitness24Seven AB",
          period: "Feb 2019 – Dec 2019",
          description:
            "Built and implemented IT processes and standards for rapid expansion in Asia and Latin America with focus on stable operations and communication.",
        },
        {
          role: "Delägare",
          company: "inCAPS AB · 8tti8tti AB",
          period: "Feb 2019 – Present",
          description:
            "Runs consulting business within IT architecture, CIO engagements, and project management.",
        },
        {
          role: "IT Architect / Enterprise Architect",
          company: "IKEA Retail Services AB",
          period: "Dec 2017 – Jan 2019",
          description:
            "Owned technical design for IKEA's future web and e-commerce solutions and communicated the vision to agile teams under SAFe moving toward a DevOps model.",
        },
        {
          role: "Senior Solution Architect · Solution Architect · IT Solution Analyst",
          company: "IKEA IT AB",
          period: "Jun 2015 – Nov 2017",
          description:
            "Started and coached agile development teams and defined target architecture for multichannel services.",
        },
        {
          role: "Head of IT · Site & Development Manager · Project Manager",
          company: "Avensia AB (INXL)",
          period: "May 2012 – May 2015",
          description:
            "Group-wide IT responsibility, people management for developers and project managers, and leadership of e-commerce and PIM projects for clients such as Byggmax, Procurator, and Mekonomen.",
        },
        {
          role: "Head of IT",
          company: "Order Nordic AB",
          period: "Aug 2010 – May 2012",
          description: "Responsible for IT environment and digital commerce.",
        },
        {
          role: "Web, e-commerce and marketing lead",
          company: "Kayak Event Sweden AB",
          period: "Aug 2009 – Aug 2010",
          description: "Owned web presence and marketing.",
        },
        {
          role: "CEO and Project Manager",
          company: "ZEGUL AB",
          period: "Oct 2007 – Jul 2009",
          description:
            "Led product and delivery projects within kayaks and boats with end-to-end responsibility for customer and supplier.",
        },
        {
          role: "Project Manager for boats and kayaks",
          company: "FANN VA-teknik AB",
          period: "Jul 2005 – Sep 2007",
          description:
            "Managed development and production of boats and kayaks for international customers.",
        },
      ]}
      education={[
        {
          degree:
            "M.Sc. in Computer Engineering (Media Technology, focus on web usability)",
          institution: "Mid Sweden University, Sundsvall",
          year: "2000 – 2005",
        },
        {
          degree: "Science/technical upper secondary education",
          institution: "Jakobsbergs gymnasium",
          year: "1996 – 1999",
        },
      ]}
    />
  );
}
